<div class="outer-container">
    <div class="domains">
        <div class="domain">
            <div class="domainTitle">Speaking</div>
            <div #speakingChartElement class="donut">
                <div class="donutHole">
                    <div class="donutHolePercent">{{speakingText}}</div>
                </div>
            </div>
        </div>
        <div class="domain">
            <div class="domainTitle">Listening</div>
            <div #listeningChartElement class="donut">
                <div class="donutHole">
                    <div class="donutHolePercent">{{listeningText}}</div>
                </div>
            </div> 
        </div>
        <div class="domain">
            <div class="domainTitle">Reading</div>
            <div #readingChartElement class="donut">
                <div class="donutHole">
                    <div class="donutHolePercent">{{readingText}}</div>
                </div>
            </div>
        </div>
        <div class="domain">
            <div class="domainTitle">Writing</div>
            <div #writingChartElement class="donut">
                <div class="donutHole">
                    <div class="donutHolePercent">{{writingText}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="description">Accuracy based on most recent 60 days</div>
</div>